import * as R from 'ramda';
import { authRequest } from './utils';

/**
 * fetchRequests :: Object -> Promise Error Object
 */
export const fetchRequests = ({
  page = 1,
  monthLimit = 2,
  start,
  end,
  sources,
  statuses,
  labels,
  assignees,
  searchTerm,
  simpleList,
  cancelToken,
  byLogHistory,
  onlyFromCompanies,
  overview,
  polling,
} = {}) => authRequest({
  method: 'GET',
  url: '/requests',
  cancelToken,
  params: {
    ...(!overview && {
      page,
      start,
      end,
      labels,
      sources,
      statuses,
      assignees,
      simpleList,
      searchTerm,
      ...(start && end && { byLogHistory }),
      ...(onlyFromCompanies && { onlyFromCompanies }),
      ...(
        (!statuses && !searchTerm && !sources && !labels
          && !assignees && !start && !end && !simpleList)
        && { monthLimit }),
    }),
    overview,
    ...(polling && { polling }),
  },
})
  .then(({ data, responseTime }) => ({ data, responseTime }));

/**
 * fetchRequests :: Object -> Promise Error Object
 */
export const fetchIncompleteRequests = cancelToken => authRequest({
  method: 'GET',
  url: '/requests/incomplete',
  cancelToken,
})
  .then(({ data }) => data);

/**
 * fetchRequestsStatistics :: Object -> Promise Error [Object]
 */
export const fetchRequestsStatistics = ({
  dateFrom,
  dateTo,
  general,
  labels,
  sources,
} = {}) => authRequest({
  method: 'GET',
  url: '/requests/requests-statistics',
  params: {
    dateFrom,
    dateTo,
    general,
    labels,
    sources,
  },
})
  .then(({ data }) => data);

/**
 * fetchRequestsOverviewStatistics :: Object -> Promise Error [Object]
 */
export const fetchRequestsOverviewStatistics = cancelToken => authRequest({
  method: 'GET',
  url: '/requests/overview-statistics',
  cancelToken,
})
  .then(({ data }) => data);

/**
 * fetchEstimationStatistics :: () -> Promise Error [Object]
 */
export const fetchEstimationStatistics = () => authRequest({
  method: 'GET',
  url: '/requests/estimation-statistics',
})
  .then(({ data }) => data);

/**
 * fetchCustomersStatistics :: Object -> Promise Error [Object]
 */
export const fetchCustomersStatistics = () => authRequest({
  method: 'GET',
  url: '/requests/customers-statistics',
})
  .then(({ data }) => data);

/**
 * deleteRequestById :: ID -> Promise Error Object
 */
export const deleteRequestById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/requests/${_id}`,
  });

/**
 * updateRequestById :: ID -> Object -> Promise Error Request
 */
export const updateRequestById = R.curry((_id, data) =>
  authRequest({
    method: 'PATCH',
    url: `/requests/${_id}`,
    data,
  })
    .then(res => res.data));

/**
 * createRequest :: Object -> Promise Error Request
 */
export const createRequest = data =>
  authRequest({
    method: 'POST',
    url: '/requests/create',
    data,
  })
    .then(res => res.data);

/**
 * fetchRequestById :: (ID, Object) -> Object -> Promise Error Request
 */
export const fetchRequestById = (requestId, cancelToken) => authRequest({
  method: 'GET',
  url: `/requests/${requestId}`,
  cancelToken,
});

/**
 * addRequestAssignee :: (ID, ID) -> Promise Error Object
 */
export const addRequestAssignee = (requestId, userId) => authRequest({
  method: 'POST',
  url: `requests/${requestId}/assignees`,
  data: {
    userId,
  },
});

/**
 * removeRequestAssignee :: (ID, ID) -> Promise Error Object
 */
export const removeRequestAssignee = (requestId, userId) => authRequest({
  method: 'DELETE',
  url: `requests/${requestId}/assignees/${userId}`,
});

/**
 * fetchTalents :: Object -> Promise Error Object
 */
export const fetchTalents = ({
  searchTerm,
  cancelToken,
} = {}) => authRequest({
  method: 'GET',
  url: '/requests/talents/search',
  cancelToken,
  params: {
    searchTerm,
  },
})
  .then(({ data }) => data);

/**
 * addRequestTalent :: (ID, ID) -> Promise Error Object
 */
export const addRequestTalent = (requestId, talentId) => authRequest({
  method: 'POST',
  url: `requests/${requestId}/talents`,
  data: {
    talentId,
  },
});

/**
 * removeRequestTalent :: (ID, ID) -> Promise Error Object
 */
export const removeRequestTalent = (requestId, talentId) => authRequest({
  method: 'DELETE',
  url: `requests/${requestId}/talents/${talentId}`,
});

/**
 * fetchProjects :: () -> Promise Error Object
 */
export const fetchProjects = () => authRequest({
  method: 'GET',
  url: '/requests/projects/simple-list',
})
  .then(({ data }) => data);



// WEBPACK FOOTER //
// ./src/api/apiko-api/requests.js